// Initialisation de la carte OpenStreetMap avec Leaflet
document.addEventListener('DOMContentLoaded', (): void => {
    // Coordonnées de l'adresse : 803 rue de la Prévôté, 59890 Quesnoy-sur-Deûle (50°42'12.4"N 2°59'09.8"E, relevé Google Maps)
    const latitude: number = 50.703439597115924;
    const longitude: number = 2.986044252381501;
    
    // Initialiser la carte centrée sur l'adresse avec un zoom par défaut
    const map = L.map('map', { scrollWheelZoom: false }).setView([latitude, longitude], 15);
    
    // Ajouter les tuiles OpenStreetMap
    L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
        attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
        maxZoom: 19,
    }).addTo(map);
    
    // Ajouter un marqueur avec popup
    const marker = L.marker([latitude, longitude]).addTo(map);
    marker.bindPopup('<b>Énergie Verte</b><br>803 rue de la Prévôté<br>59890 Quesnoy-sur-Deûle<br><strong>Tél :</strong> <a href="tel:0320663540">03 20 66 35 40</a>').openPopup();
});


